/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { types } from 'mobx-state-tree';

export const ThumbnailError = types.model('ThumbnailError', {
	message: types.string
});

export const ThumbnailWarning = types.model('ThumbnailWarning', {
	message: types.string
});

export const Thumbnail = types
	.model('Thumbnail', {
		widgetId: types.string,
		type: types.optional(types.string, ''),
		data: types.optional(types.string, ''),
		error: types.union(ThumbnailError, types.undefined),
		warning: types.union(ThumbnailWarning, types.undefined)
	})
	.views((self) => ({
		hasError() {
			return !!self.error;
		},
		hasWarning() {
			return !!self.warning;
		}
	}));

export default types
	.model('Thumbnails', {
		items: types.optional(types.array(Thumbnail), [])
	})
	.views((self) => ({
		getItemByWidgetId(id) {
			return self.items.find(item => item.widgetId === id);
		},
		getItemIndexByWidgetId(id) {
			return self.items.findIndex(item => item.widgetId === id);
		}
	}))
	.actions((self) => {

		const _addItem = item => {
			if (!item || !item.widgetId) {
				throw new Error('Invalid thumbnail item provided');
			}

			const index = self.getItemIndexByWidgetId(item.widgetId);
			if (index === -1) {
				self.items.push(item);
			} else {
				self.items.splice(index, 1, item);
			}
		};

		function setItems(items) {
			self.items = items;
		}

		/**
		 * Add a single item
		 *
		 * @param {Thumbnail} item - single thumbnail model instance to add
		 */
		function addItem(item) {
			_addItem(item);
		}

		/**
		 * Add multiple items
		 *
		 * @param {Thumbnail[]} items - multiple thumbnail model instances to add
		 */
		function addItems(items) {
			items.forEach(item => _addItem(item));
		}

		return {
			setItems,
			addItem,
			addItems
		};
	});



// WEBPACK FOOTER //
// ./src/js/components/cards/thumbnails/ThumbnailsModel.js